var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pdfUrl)?_c('div',{ref:"pdfContainer",staticClass:"mt-5"},[_c('vue-pdf-app',{staticStyle:{"height":"100vh"},attrs:{"pdf":_vm.pdfUrl,"config":_vm.config}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }